const PRICE_EPS = 1e-6;

/**
 * תג "הכי זול" על כל ההצעות שמחיר לאדם שלהן שווה למינימום ברשימה (לא תלוי במיון).
 */
export function cheapestOfferIdsByPerPerson(offers) {
  if (!Array.isArray(offers) || offers.length === 0) return new Set();
  let min = Infinity;
  for (const o of offers) {
    const v = Number(o?.pricePerPerson);
    if (Number.isFinite(v) && v < min) min = v;
  }
  if (!Number.isFinite(min)) return new Set();
  const ids = new Set();
  for (const o of offers) {
    if (o?.id == null) continue;
    const v = Number(o.pricePerPerson);
    if (Number.isFinite(v) && Math.abs(v - min) <= PRICE_EPS) ids.add(o.id);
  }
  return ids;
}
